import { FC } from 'react';
import { Text } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import SunshineModal from 'components/_core/SunshineModal';
import { useModal } from 'components/ModalProvider/hooks';
import useToast from 'components/ToastProvider/useToast';

import useDeleteClientContact from '../../../../hooks/useDeleteClientContact';
import { Contact } from '../../types';
import locales from './locales';

interface DeleteContactModalProps {
  contact: Contact;
}

const DeleteContactModal: FC<DeleteContactModalProps> = ({ contact }) => {
  const { hideModal } = useModal();
  const { showToast } = useToast();

  const { clientContactId, clientId, firstName, lastName } = contact;

  const { deleteClientContact, loading } = useDeleteClientContact(clientId);

  const onSubmit = async () => {
    const { errors } = await deleteClientContact(clientContactId);

    hideModal();

    if (errors) {
      showToast({ message: locales.message.error, type: 'error' });
      return;
    }

    showToast({
      message: locales.message.success,
      type: 'success',
    });
  };

  return (
    <SunshineModal isOpen onClose={hideModal}>
      <SunshineModal.Header />

      <SunshineModal.Body>
        <Heading marginBottom="space-16">
          {locales.formatString(locales.title, { firstName, lastName })}
        </Heading>
        <Text marginBottom="space-16">{locales.description}</Text>
      </SunshineModal.Body>

      <SunshineModal.Footer>
        <Button
          icon="trash"
          isLoading={loading}
          onClick={onSubmit}
          variant="danger"
        >
          {locales.confirm}
        </Button>
      </SunshineModal.Footer>
    </SunshineModal>
  );
};

export default DeleteContactModal;
